import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const us = () => import('../views/us')
const product = () => import('../views/product')
const strength = () => import('../views/strength')
const credential = () => import('../views/credential')
const area = () => import('../views/area')
const news = () => import('../views/news')
const contact = () => import('../views/contact')
const product_detail = () => import('../views/product_detail')
const news_detail = () => import('../views/news_detail')
const layouts = () => import('../views/layouts')

const dashboard = () => import('../admin/dashboard')
const admin_product = () => import('../admin/product')
const product_list = () => import('../admin/product_list')
const aproduct_detail = () => import('../admin/product_detail')
const login = () => import('../admin/login')

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '',
    redirect: '/web'
  }, {
    path: '/web',
    component: layouts,
    children: [{
      path: '/web',
      component: HomePage
    }, {
      path: '/us',
      component: us
    }, {
      path: '/product',
      component: product
    }, {
      path: '/strength',
      component: strength
    }, {
      path: '/credential',
      component: credential
    }, {
      path: '/area',
      component: area
    }, {
      path: '/news',
      component: news
    }, {
      path: '/contact',
      component: contact
    }, {
      path: '/product_detail',
      component: product_detail
    }, , {
      path: '/news_detail',
      component: news_detail
    }]
  }, {
    path: '/admin',
    redirect: '/admin/login'
  },{
    path: '/admin/product',
    component: admin_product,
    meta: {
      authRequired: true
    },
  }, {
    path: '/admin/product_list',
    component: product_list,
    meta: {
      authRequired: true
    },
  }, {
    path: '/admin/product_detail',
    component: aproduct_detail,
    meta: {
      authRequired: true
    },
  }, {
    path: '/admin/login',
    component: login,
  }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js